import { ReactNode } from 'react'
import { cn } from '@/utils/block'

export const cnButton = cn('button')

export type ButtonProps = {
  children?: ReactNode
  onClick?: () => void
  className?: string
}

export function Button({ children, className, onClick }: ButtonProps) {
  return (
    <button className={cnButton({}, [className])} onClick={onClick}>
      {children}
    </button>
  )
}
